module.exports = __webpack_public_path__ + "img/device_am35_c.55639072.png";